import {
    DeliveryActions,
    UPSERT, CLEAR
} from './delivery-details.actions';

import { Address } from '../../../model/address.model';

export interface State {
    address: Address;
    comments: string;
}

const initialState = {
    address: null,
    comments: ''
};

export function reducer(state = initialState, action: DeliveryActions) {
    switch (action.type) {
    case UPSERT:
        return {
            ...state,
            address: { ...action.payload.address },
            comments: action.payload.comments
        };
    case CLEAR:
        return {
            ...state,
            address: null,
            comments: ''
        };
    default:
        return state;
    }
}

export const getDeliveryAddress = (state: State) => state.address;

